var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"show-more-btn d-flex justify-center my-6",class:{'no-slots': !_vm.avaliableSlots, 'no-hold': !_vm.onHoldShowing},attrs:{"text":""}},[_vm._v("Show more ("+_vm._s(_vm.hiddenItemsCount)+")")])}
var staticRenderFns = []

export { render, staticRenderFns }